import React from 'react';
import './VeilleTechno.css';

// remplacer ces assets par des images Hypershield ensuite.
import hypershieldImage from '../assets/hypershield2.jpg';
import whyImage from '../assets/hypershield1.jpg';
import whatImage from '../assets/hypershield3.jpg';
import howImage from '../assets/hypershieldmain.jpg';

function VeilleTechno() {
  // Sujet principal : Cisco Hypershield
  const mainTopic = {
    titre: "Cisco Hypershield : la cybersécurité IA-native",
    description: `
      Annoncé le 18 avril 2024, Cisco Hypershield est une approche “IA-native” de la cybersécurité.
      La mise à disposition est indiquée depuis 2025 dans la dernière série de commutateurs Nexus 9300.
    `,
    details: [
      {
        sousTitre: "Pourquoi une nouvelle approche sécurité ?",
        texte: `
          - Données de santé (cliniques) : obligations HDS/RGPD.
          - Dossiers d’avocats : confidentialité absolue.
          - Rançongiciels et failles “0-day” en forte hausse.
          - Petite équipe IT (7 employés) : temps limité pour analyser les alertes.
        `
      },
      {
        sousTitre: "Qu’est-ce que Hypershield ?",
        texte: `
          - Mini-pare-feux autonomes déployés sur chaque serveur, VM ou conteneur.
          - Bloque une faille avant la sortie du patch grâce à l’IA.
          - Met à jour et teste les règles sur un trafic “jumeau” pour éviter les coupures.
        `
      },
      {
        sousTitre: "Comment ça marche ?",
        texte: `
          - AI Rule Engine : note la gravité d’une CVE et écrit une règle “sur mesure”.
          - eBPF : capteurs au cœur du système.
          - DPU / SmartNIC : filtrage et analyse directement sur la carte réseau, sans charger le CPU.
        `
      },
      {
        sousTitre: "Valeur pour Quietec",
        texte: `
          Besoin / enjeu :
          - Confidentialité des patients
          - Secrets pro avocats
          - Alertes nombreuses
          - Montée en compétence

          Apport Hypershield :
          - Micro-segmentation automatique
          - Blocage 0-day + journalisation complète
          - IA réduit le “noise” (faux positifs) et le MTTR (temps de résolution)
          - eBPF, automatisation SecOps, future certif Cisco Secure
        `
      },
      {
        sousTitre: "Lexique express",
        texte: `
          - eBPF : capteur noyau ultra-léger
          - DPU : carte réseau intelligente
          - 0-day : faille encore inconnue
          - Micro-segmentation : cloisonnement fin entre services
        `
      }
    ],
    conclusion: `
      Hypershield pourrait offrir à Quietec une défense “grande entreprise” sans recruter une armée
      d’analystes, et me permettre d’acquérir des compétences sécurité + IA dont nos clients auront besoin demain.
    `,
    image: hypershieldImage
  };

  // Cartes “navigation” vers les sections (tout reste sur le même sujet)
  const veilleItems = [
    {
      id: 1,
      titre: "Pourquoi une nouvelle approche ?",
      description:
        "Contexte : HDS/RGPD, confidentialité, hausse des 0-day/ransomwares, équipe IT réduite.",
      lien: "#pourquoi",
      image: whyImage
    },
    {
      id: 2,
      titre: "Qu’est-ce que Hypershield ?",
      description:
        "Mini pare-feux autonomes par workload, blocage avant patch via IA, tests sur trafic jumeau.",
      lien: "#questceque",
      image: whatImage
    },
    {
      id: 3,
      titre: "Comment ça marche ?",
      description:
        "AI Rule Engine, eBPF au cœur du système, DPU/SmartNIC pour filtrer/analyser sans charger le CPU.",
      lien: "#comment",
      image: howImage
    }
  ];

  // Helper: créer un id HTML stable à partir d’un sous-titre
  const toId = (s) =>
    s
      .toLowerCase()
      .replace(/’/g, "'")
      .replace(/[^a-z0-9]+/g, '')
      .trim();

  return (
    <div className="veille-container">
      <h1 className="veille-title fade-in-up">Veille Technologique</h1>
      <p className="veille-intro fade-in-up">
        Présentation d’un sujet de veille : <strong>Cisco Hypershield</strong>, une approche de cybersécurité IA-native,
        avec contexte, fonctionnement, valeur pour Quietec et un lexique.
      </p>

      {/* ---- Sujet principal détaillé ---- */}
      <div className="main-topic-card fade-in-up">
        <h2>{mainTopic.titre}</h2>

        <img
          src={mainTopic.image}
          alt="Illustration Cisco Hypershield"
          className="main-topic-image"
        />

        <p className="main-topic-desc">{mainTopic.description}</p>

        {mainTopic.details.map((detail, index) => {
          // ids manuels pour les 3 premières sections + fallback
          const anchor =
            detail.sousTitre.includes("Pourquoi") ? "pourquoi" :
            detail.sousTitre.includes("Qu’est-ce") ? "questceque" :
            detail.sousTitre.includes("Comment") ? "comment" :
            toId(detail.sousTitre);

          return (
            <div key={index} className="main-topic-section" id={anchor}>
              <h3>{detail.sousTitre}</h3>
              <p>{detail.texte}</p>
            </div>
          );
        })}

        <p className="main-topic-conclusion">{mainTopic.conclusion}</p>
      </div>

      {/* ---- Aperçu des sections ---- */}
      <h3 className="secondary-title fade-in-up">Accès rapide</h3>
      <div className="veille-grid fade-in-up">
        {veilleItems.map((item) => (
          <div key={item.id} className="veille-card">
            <img
              src={item.image}
              alt={`Illustration de ${item.titre}`}
              className="veille-card-image"
            />
            <div className="veille-card-text">
              <h4>{item.titre}</h4>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default VeilleTechno;
